const ButtonSort = ({ handleSort, field = null, direction = 'asc', className = 'text-gray-400' }) => {
    return (
        <button 
            onClick={() => handleSort(field)}
            className={`text-sm ${className}`}
        >
            {(
                <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24" fill="none" stroke="currentColor"
                strokeWidth="4" className="w-6 h-6"
                >
                {direction === 'asc' ? (
                    <path d="M7 14l5-5 5 5H7z" />
                ) : (
                    <path d="M7 10l5 5 5-5H7z" />
                )}
                </svg>
            )}
        </button>
    );
};

export default ButtonSort;
